import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";

const Spanish = {
  weekdays: {
    shorthand: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
    longhand: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
  },
  months: {
    shorthand: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
    longhand: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
  },
  firstDayOfWeek: 1,
  time_24hr: true,
};

export default class extends Controller {
  static values = {
    enableTime: { type: Boolean, default: false },
    locale: { type: String, default: "es" },
  };

  connect() {
    this.picker = flatpickr(this.element, {
      locale: Spanish,
      enableTime: this.enableTimeValue,
      dateFormat: this.enableTimeValue ? "Y-m-d H:i" : "Y-m-d",
      time_24hr: true,
      allowInput: true,
    });
  }

  disconnect() {
    this.picker?.destroy();
  }
}
